import { render, staticRenderFns } from "./WinnerPage.vue?vue&type=template&id=33c2b19a&scoped=true&"
import script from "./WinnerPage.vue?vue&type=script&lang=js&"
export * from "./WinnerPage.vue?vue&type=script&lang=js&"
import style0 from "./WinnerPage.vue?vue&type=style&index=0&id=33c2b19a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2b19a",
  null
  
)

export default component.exports